module.exports = __webpack_public_path__ + "img/fi-rr-document-signed.42addcf0.svg";